import { useEffect, useState } from "react";
import { Navigate, Outlet, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import axios from "axios";
import { SET_ACCESS_TOKEN, RESTE_ALL_AUTH_DATA, SET_PROFILE_AUTH } from "../../../redux/action/auth/type";
import { SET_SERVERTIME_INFO } from "../../../redux/action/info/type";
import { useCookies } from "react-cookie";

const ProtectedLayout = (props) => {

  const accessToken = useSelector((state) => state.auth.accessToken);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const profile = useSelector((state) => state.auth.profile);

  const [loading, setLoading] = useState(true);

  const [cookies, setCookies] = useCookies()

  // 1) فچ پروفایل با access token
  const fetchProfile = async (token) => {
    try {

      const res = await axios.get("https://my-sarad-back.liara.run/api/user/profile", {
        headers: { Authorization: `Bearer ${token}` }
      });

      dispatch({
        type: SET_PROFILE_AUTH,
        payload: res.data?.user
      })

      if(res.data?.dateNowServer){

        dispatch({
          type: SET_SERVERTIME_INFO,
          payload: res.data?.dateNowServer
        })
      
      }

      return res.data?.user; 
    
    } catch (err) {
      return null;
    }

  };

  // 2) گرفتن Access Token جدید با Refresh Token
  const refreshAccess = async () => {
    try {

      const res = await axios.post(
        "https://my-sarad-back.liara.run/api/auth/refresh-token",
        {refreshToken: cookies?.refreshToken}
      );

      const newAccess = res.data?.accessToken;

      // ذخیره در Redux
      dispatch({ type: SET_ACCESS_TOKEN, payload: newAccess });

      return newAccess;
    } catch (err) {
      return null;
    }
  };

  useEffect(() => {

    const checkAuth = async () => {

      let token = accessToken;

      // اگر access token نداریم
      if (!token) {
        token = await refreshAccess();
        
        if (!token) {
          dispatch({ type: RESTE_ALL_AUTH_DATA });
          navigate("/auth");
          return;
        }

      }

      // تست پروفایل
      let profile = await fetchProfile(token);

      // اگر access token expire شده
      if (!profile) {

        const newAccess = await refreshAccess();

        if (!newAccess) {
          dispatch({ type: RESTE_ALL_AUTH_DATA });
          navigate("/auth");
          return;
        }

        profile = await fetchProfile(newAccess);

        if (!profile) {
          dispatch({ type: RESTE_ALL_AUTH_DATA });
          navigate("/auth");
          return;
        }
        
      }

      setLoading(false);
    };

    checkAuth();

  }, []);

  if (loading) 
    return (
      <div className="flex min-h-[90vh] items-center justify-center">
        در حال بررسی ورود...
      </div>
    )

  return (
    <div>
      {props.children}
    </div>
  );


};

export default ProtectedLayout;